// auth strings (fr).
// Machine-drafted — review with a native speaker before launch.
const auth = {
	auth: {
		// Titles & headings
		signInTitle: 'Connectez-vous à votre compte',
		signUpTitle: 'Créer un nouveau compte',
		signUpToAccount: 'Inscrivez-vous à votre compte',
		resetYourPassword: 'Réinitialisez votre mot de passe',

		// Links & secondary actions
		or: 'Ou',
		orLower: 'ou',
		orDivider: 'OU',
		createNewAccount: 'Créer un nouveau compte',
		alreadyHaveAccountLogin: 'Vous avez déjà un compte ? Connectez-vous',
		alreadyHaveAccount: 'Vous avez déjà un compte ?',
		logIn: 'Se connecter',
		forgotPassword: 'Mot de passe oublié ?',

		// Buttons
		signIn: 'Se connecter',
		signUp: "S'inscrire",
		signInWithGoogle: 'Se connecter avec Google',
		signUpWithGoogle: "S'inscrire avec Google",
		send: 'Envoyer',

		// Field labels & placeholders
		emailAddress: 'Adresse e-mail',
		yourEmailAddress: 'Votre adresse e-mail',
		emailPlaceholder: 'vous@exemple.com',
		enterEmailAddress: 'Saisissez votre adresse e-mail',
		password: 'Mot de passe',
		enterPassword: 'Saisissez votre mot de passe',
		rememberMe: 'Se souvenir de moi',

		// Terms & consent
		agreeToOur: 'En vous inscrivant, vous acceptez nos',
		termsOfService: "conditions d'utilisation",
		and: 'et',
		privacyPolicy: 'politique de confidentialité',

		// Invitation
		invitedToJoin: "Vous avez été invité à rejoindre l'espace de travail %{workspace}",

		// Testimonials panel
		clientsSayHeading: 'Ce que disent nos clients',
		companiesTrust: 'Plus de 1000 entreprises créent de meilleures relations avec CardClan',

		// Alerts / dialog titles
		errorTitle: 'Erreur',
		successTitle: 'Succès',
		oops: 'Oups !',

		// Alert / validation messages
		passwordResetLinkSent: 'Un lien de réinitialisation du mot de passe a été envoyé à votre adresse e-mail.',
		emailNotRegistered: "Cet e-mail n'est pas enregistré.",
		wrongPassword: 'Le mot de passe que vous avez saisi est incorrect.',
		unknownError: 'Une erreur inconnue est survenue. Contactez le support à support@cardclan.io.',
		invalidEmail: "Format d'e-mail non valide",
		emailRequired: "L'e-mail est obligatoire",
		passwordRequired: 'Le mot de passe est obligatoire',
		passwordRules:
			'Le mot de passe doit comporter de 6 à 18 caractères, avec au moins 1 majuscule, 1 minuscule et 1 chiffre.',
	} as Record<string, string>,
};
export default auth;
